<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <!-- <el-button type="primary" size="small" @click="add"  icon="el-icon-plus" plain>添加</el-button> -->
                        <el-input
                            size="small"
                            style="width:300px;"
                            placeholder="请输入用户手机号 / 任务编号"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-select size="small" style="margin-left:30px;width:100px"  v-model="queryModel.payMode" clearable placeholder="支付方式">
                            <el-option key="1" label="账户余额" value="1"> </el-option>
                            <el-option key="2" label="信用额度" value="2"> </el-option>
                        </el-select>
                        <el-select size="small" style="margin-left:30px;width:100px"  v-model="queryModel.rebateMethod" clearable placeholder="返款方式">
                            <el-option key="0" label="平台返款" value="0"> </el-option>
                            <el-option key="1" label="商家自反" value="1"> </el-option>
                        </el-select>
                        <el-select size="small" style="margin-left:30px;width:100px"  v-model="queryModel.keyType" clearable placeholder="进店方式">
                            <el-option key="0" label="关键字" value="0"> </el-option>
                            <el-option key="1" label="淘口令" value="1"> </el-option>
                            <el-option key="2" label="二维码" value="2"> </el-option>
                        </el-select>
                        <el-select size="small" style="margin-left:30px;width:100px"   v-model="queryModel.status" clearable placeholder="任务状态">
                            <el-option key="0" label="待支付" value="0"> </el-option>
                            <el-option key="1" label="待审核" value="1"> </el-option>
                            <el-option key="2" label="进行中" value="2"> </el-option>
                            <el-option key="3" label="已完成" value="3"> </el-option>
                            <el-option key="4" label="不通过" value="4"> </el-option>
                        </el-select>
                        <el-date-picker
                        size="small" style="width:300px;margin-left:30px"
                        v-model="queryModel.createTimes"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>

                        <el-checkbox style="margin-left:20px" v-model="queryModel.isMe">分配给我</el-checkbox>
                        <el-checkbox  v-model="queryModel.hasAbandoned">显示作废</el-checkbox>

                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="批量结算" placement="top">
                            <el-button type="primary" size="small" :loading="isOperating"  style="margin-left:15px;" @click="batchOver" icon="el-icon-check" plain circle></el-button>
                        </el-tooltip>

                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    @selection-change="taskHandleSelectionChange"
                    :height="bodyHeight-130"
                    v-loading="isLoading"
                    :data="tableData"
                    style="width: 100%">
                        <el-table-column
      type="selection"
      width="55">
    </el-table-column>

                        <el-table-column
                        width="240"
                            label="任务编号">
                            <template slot-scope="scope">
                                <el-link target="_blank" @click="taskGetDetail(scope.row)"  type="primary">{{scope.row.Code}}</el-link>
                                <el-tag size="mini" v-if="scope.row.IsRefundOrder" style="margin-left:10px" effect="dark">退款单 </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                        prop="MemberName"
                            label="所属用户">
                            <!-- <template slot-scope="scope">
                                <el-link target="_blank" icon="el-icon-user-solid"  type="primary">{{scope.row.}}</el-link>
                            </template> -->
                        </el-table-column>
                        <el-table-column
                            width="100px"
                            label="垫付额度">
                            <template slot-scope="scope">
                                <span v-if="scope.row.Advance>0">{{scope.row.Advance.toFixed(2)}}元</span>
                                <span v-else>无垫付额度</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="店铺名称">
                            <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.ShopName" placement="bottom">
                                <span v-if="scope.row.ShopType==1" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#ff6a3c;border-radius:5px"  src="../assets/taobao.png">
                                        {{scope.row.ShopName}}
                                        </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==2" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/jindong.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==6" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/dy.jpg">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span  v-else>
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#fc5487;border-radius:5px"  src="../assets/pinduoduo.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                            </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="120px"
                            label="费用明细">
                            <template slot-scope="scope">
                                <el-tooltip   class="item" effect="dark" placement="bottom">
                                    <div slot="content">
                                        <p>预计商品金额：￥ {{scope.row.ExpectedPrice.toFixed(2)}}</p>
                                        <p>预计佣金：￥ {{scope.row.ExpectedCommission.toFixed(2)}}</p>
                                        <p>实际商品金额：{{scope.row.ActualPrice==0?'暂无':'￥ '+scope.row.ActualPrice.toFixed(2)}}</p>
                                        <p>实际佣金：{{scope.row.ActualCommission==0?'暂无':'￥ '+scope.row.ActualCommission.toFixed(2)}}</p>
                                    </div>
                                     <el-link  icon="el-icon-money"  type="primary">￥{{scope.row.Total.toFixed(2)}}</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="120px"
                            label="商家要求">
                            <template slot-scope="scope">
                                <el-tooltip   class="item" effect="dark" placement="bottom">
                                    <div slot="content">
                                        <p>期望完成时间：
                                            <span >{{scope.row.ExpectedOverTime.toString().split(' ')[0]}}</span>
                                        </p>
                                        <p>返款方式：
                                            <span v-if="scope.row.RebateMethod==0">平台返款</span>
                                            <span v-else-if="scope.row.RebateMethod==1">商家自反</span>
                                            <span  v-else>平台返款</span>
                                        </p>
                                        <p>进店方式：
                                            <span v-if="scope.row.KeyType==1">淘口令</span>
                                            <span v-else-if="scope.row.KeyType==2">二维码</span>
                                            <span  v-else>关键字</span>
                                        </p>
                                        <p>淘客订单拦截：
                                            <span v-if="scope.row.Intercept==false">否</span>
                                            <span v-else-if="scope.row.Intercept==true">是</span>
                                            <span v-else>否</span>
                                        </p>
                                        <p>买家性别要求：
                                            <span v-if="scope.row.SwipeGender==1">男</span>
                                            <span v-else-if="scope.row.SwipeGender==2">女</span>
                                            <span  v-else>不限</span>
                                        </p>
                                        <p>买家年龄要求： 
                                            <span v-if="scope.row.SwipeAge==1">22岁以下</span>
                                            <span v-else-if="scope.row.SwipeAge==2">23岁-28岁</span>
                                            <span v-else-if="scope.row.SwipeAge==3">29岁-35岁</span>
                                            <span v-else-if="scope.row.SwipeAge==4">36岁-45岁</span>
                                            <span v-else-if="scope.row.SwipeAge==5">46岁以上</span>
                                            <span  v-else>不限</span>
                                        </p>
                                        <p>买家信誉要求：
                                            <span v-if="scope.row.SwipeBuyerGoodNum==1">二心以上</span>
                                            <span v-else-if="scope.row.SwipeBuyerGoodNum==2">三心以上</span>
                                            <span v-else-if="scope.row.SwipeBuyerGoodNum==3">四心以上</span>
                                            <span v-else-if="scope.row.SwipeBuyerGoodNum==4">五心以上</span>
                                            <span v-else-if="scope.row.SwipeBuyerGoodNum==5">一钻以上</span>
                                            <span  v-else>不限</span>
                                        </p>
                                        <p>特殊要求：{{scope.row.Remark}}</p>
                                        <p>商家要求：{{scope.row.SwipeRemark}}</p>
                                    </div>
                                     <el-link @click="setRequirement(scope.row)" type="primary">{{scope.row.ExpectedOverTime.toString().split(' ')[0]}}</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column
                            label="第三方平台信息">
                            <template slot-scope="scope">
                                <el-link target="_blank" icon="el-icon-s-platform"  v-if="scope.row.ExternalName==''" type="info">暂无</el-link>
                                <el-tooltip v-else class="item" effect="dark" :content="scope.row.ExternalCodes" placement="bottom">
                                    <el-link @click="editTask(scope.row)" icon="el-icon-user" type="primary">{{scope.row.ExternalName}}</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column> -->
                        <el-table-column
                            prop="CreateTime"
                            width="160"
                            label="创建时间">
                        </el-table-column>
                        <el-table-column
                            label="审核信息">
                            <template slot-scope="scope">
                                <el-link v-if="scope.row.ReviewManagerName==''" icon="el-icon-user" type="info">暂无</el-link>
                                <el-tooltip  v-else  class="item" effect="dark" placement="bottom-start">
                                    <div slot="content">
                                        时间：{{scope.row.ReviewTime}}<br/><br/>
                                        备注：{{scope.row.ReviewRemark}}<br/><br/>
                                    </div>
                                    <el-link icon="el-icon-user" type="primary">{{scope.row.ReviewManagerName}}</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="80"
                            label="状态">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" type="info" v-if="scope.row.Status==0">待支付</el-tag>
                                <el-tag size="mini" effect="plain" v-else-if="scope.row.Status==1">待审核</el-tag>
                                <el-tag size="mini" effect="plain" type="warning" v-else-if="scope.row.Status==2">进行中</el-tag>
                                <el-tag size="mini" effect="plain" type="success" v-else-if="scope.row.Status==3">已完成</el-tag>
                                <el-tag size="mini" effect="plain" type="danger" v-else-if="scope.row.Status==4">不通过</el-tag>
                                <el-tag size="mini" effect="plain" type="danger" v-else>作废</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="80"
                            label="预计单数">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="dark" type="danger">{{scope.row.ExpectedOrderCount}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="80"
                            label="完成单数">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="dark" type="info" v-if="scope.row.OrderCount==0">暂无</el-tag>
                                <el-tag size="mini" effect="dark" v-else>{{scope.row.OrderCount}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="120"
                            label="开始-结束">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect=""  >{{scope.row.StartHour}} - {{scope.row.EndHour}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="180px"
                            label="操作">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="导出工单内容" placement="bottom">
                                    <el-button size="mini" @click="taskGetExl(scope.row)"  icon="el-icon-download" circle></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="导出未做工单" placement="bottom">
                                    <el-button size="mini" @click="taskGetExlNoDone(scope.row)"  icon="el-icon-tickets" circle></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" v-if="scope.row.Status==1" effect="dark" content="审核通过" placement="bottom">
                                    <el-button type="success" size="mini" @click="pass(scope.row)"  icon="el-icon-check" circle></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" v-if="scope.row.Status==1"  effect="dark" content="审核不通过" placement="bottom">
                                    <el-button type="danger" size="mini" @click="over(scope.row)"  icon="el-icon-close" circle></el-button>
                                </el-tooltip>
                                <!-- <el-tooltip class="item" v-if="scope.row.Status==2&&scope.row.IsAssign"  effect="dark" content="停止任务，不再派单" placement="bottom">
                                    <el-button type="danger" size="mini" @click="pause(scope.row)"  icon="el-icon-video-pause" circle></el-button>
                                </el-tooltip> -->
                                <el-tooltip class="item" v-if="scope.row.Status==0"  effect="dark" content="废弃任务" placement="bottom">
                                    <el-button type="danger" size="mini" @click="abandoned(scope.row)"  icon="el-icon-delete" circle></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog title="补充信息" :visible.sync="dialogFormVisible" width="400px">
            <el-form  :model="overModel"  :rules="rules" ref="ruleForm" label-width="100px">
                <!-- <el-form-item label="名称：" >
                    <el-input placeholder="请输入第三方平台名称" v-model="overModel.externalName"></el-input>
                </el-form-item>
                <el-form-item label="编号：" >
                    <el-input placeholder="请输入第三方平台编号（,隔开）" v-model="overModel.externalCodes"></el-input>
                </el-form-item> -->
                <el-form-item label="备注：">
                    <el-input placeholder="如有需要，填写备注" v-model="overModel.remark"></el-input>
                </el-form-item>
                <el-form-item label="开始时间：">
                    <el-input placeholder="任务开始时间，24小时制" v-model="overModel.startHour"></el-input>
                </el-form-item>
                <el-form-item label="结束时间：">
                    <el-input placeholder="任务结束时间，24小时制" v-model="overModel.endHour"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitOver">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="修改期望完成日期" :visible.sync="setExpectedOverTimeVisible" width="400px">
            <el-form    label-width="100px">
                <el-form-item label="日期：" >
                        <el-date-picker
                            v-model="setRow.ExpectedOverTime"
                            type="date"
                            placeholder="请选择期望完成日期">
                        </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="setExpectedOverTimeVisible = false">取 消</el-button>
                <el-button type="primary" @click="setExpectedOverTimeSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="设置问答" :visible.sync="problemVisible" width="400px">
            <el-form  :model="problemModel"  :rules="problemRules" ref="problemForm" label-width="100px">
                <el-form-item label="问题：" prop="problem">
                    <el-input type="textarea" :rows="3" placeholder="请输入问题" v-model="problemModel.problem"></el-input>
                </el-form-item>
                <el-form-item label="答案：" prop="answer">
                    <el-input placeholder="请输入答案" v-model="problemModel.answer"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="problemVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitproblem">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="修改商家要求" :visible.sync="requirementVisible" width="500px">
            <el-form  :model="requirementModel"  ref="requirementForm" label-width="110px">
                <el-form-item label="期望完成日期：" >
                        <el-date-picker
                            v-model="requirementModel.expectedOverTime"
                            type="date"
                            placeholder="请选择期望完成日期">
                        </el-date-picker>
                </el-form-item>
                <el-form-item label="返款方式：">
                    <el-radio-group v-model="requirementModel.rebateMethod">
                        <el-radio :label="0">平台返款</el-radio>
                        <el-radio :label="1">商家自反</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="进店方式："  prop="problem">
                    <el-select size="small" style="width:260px"  v-model="requirementModel.keyType" placeholder="进店方式">
                        <el-option label="关键字" :value="0"> </el-option>
                        <el-option label="淘口令" :value="1"> </el-option>
                        <el-option label="二维码" :value="2"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="淘客订单拦截：">
                    <!-- <el-switch v-model="requirementModel.intercept">
                    </el-switch> -->
                    <el-radio-group v-model="requirementModel.intercept">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="买家性别要求："  prop="problem">
                    <el-select size="small" style="width:260px"  v-model="requirementModel.swipeGender" placeholder="性别">
                        <el-option label="不限" :value="0" aria-checked=""> </el-option>
                        <el-option label="男" :value="1"> </el-option>
                        <el-option label="女" :value="2"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="买家年龄要求："  prop="problem">
                    <el-select size="small" style="width:260px"  v-model="requirementModel.swipeAge" placeholder="年龄">
                        <el-option aria-checked="" label="不限" :value="0"> </el-option>
                        <el-option label="22岁以下" :value="1"> </el-option>
                        <el-option label="23岁-28岁" :value="2"> </el-option>
                        <el-option label="29岁-35岁" :value="3"> </el-option>
                        <el-option label="36岁-45岁" :value="4"> </el-option>
                        <el-option label="46岁以上" :value="5"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="买家信誉要求："  prop="problem">
                    <el-select size="small" style="width:260px"  v-model="requirementModel.swipeBuyerGoodNum" placeholder="年龄">
                        <el-option label="不限" :value="0"> </el-option>
                        <el-option label="二心以上" :value="1"> </el-option>
                        <el-option label="三心以上" :value="2"> </el-option>
                        <el-option label="四心以上" :value="3"> </el-option>
                        <el-option label="五心以上" :value="4"> </el-option>
                        <el-option label="一钻以上" :value="5"> </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="特殊要求：" prop="problem">
                    <el-input type="textarea" :rows="3" placeholder="请输入商家要求" v-model="requirementModel.remark"></el-input>
                </el-form-item>
                <el-form-item label="商家要求：" prop="problem">
                    <el-input type="textarea" :rows="3" placeholder="请输入特殊要求" v-model="requirementModel.swipeRemark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="requirementVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitRequirement">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="添加订单" :visible.sync="addOrderVisible" width="500px">
            <el-form  :model="addOrderModel"  :rules="orderRules" ref="orderForm" label-width="130px">
                <el-form-item label="买手手机号：" prop="SwipePhone">
                    <el-input  placeholder="请输入买手手机号" v-model="addOrderModel.SwipePhone"></el-input>
                </el-form-item>
                <el-form-item label="买手提交单号：" prop="OrderCode">
                    <el-input  placeholder="请输入买手提交单号：" v-model="addOrderModel.OrderCode"></el-input>
                </el-form-item>
                <el-form-item label="买手阿里旺旺：" prop="AliTrademanager">
                    <el-input  placeholder="请输入买手阿里旺旺：" v-model="addOrderModel.AliTrademanager"></el-input>
                </el-form-item>
                <el-form-item label="买手实际垫付：" prop="AdvanceMoney">
                    <el-input  placeholder="请输入买手实际垫付金额：" v-model="addOrderModel.AdvanceMoney"></el-input>
                </el-form-item>
                <el-form-item label="成本佣金：" prop="Cost">
                    <el-input  placeholder="请输入成本佣金：" v-model="addOrderModel.Cost"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" >
                <el-button :loading="isOperating"  @click="addOrderVisible = false">取 消</el-button>
                <el-button :loading="isOperating" type="primary" @click="addOrder">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog  title="批量派单" width="1200px" :visible.sync="batchDispatchVisible">
            <div v-loading="loadingSwipe">
            <div style="width:300px;float:left">
                <el-input size="small" placeholder="请输入 电话/姓名/QQ/旺旺号" v-model="queryTxt" >
                    <el-button @click="serachSwipe" size="small" slot="append" icon="el-icon-search"></el-button>
                </el-input>
            </div>
            <div style="float:left;line-height:32px;margin-left:20px">
                待分配订单&nbsp;<el-tag size="mini" effect="plain">{{ undoneNum }}</el-tag>&nbsp;,
                已勾选&nbsp;<el-tag size="mini" effect="plain">{{ selSwipeRow.length }}</el-tag>
            </div>
            
            <el-button @click="fenpei" :disabled="selSwipeRow.length==0" type="primary" style="float:right" size="small">分配</el-button>
            <el-button @click="huanyipi"  style="float:right;margin-right:20px" size="small">换一批</el-button>
            
            <el-table  @selection-change="swipeSelectionChange" :data="swipeList">
                <el-table-column
                type="selection"
                width="55">
                </el-table-column>
                <el-table-column width="160" label="手机" >
                    <template slot-scope="scope">
                        {{scope.row.Phone}}
                        <el-tag style="cursor:pointer" type="danger" size="mini" v-if="!scope.row.IsOld" effect="plain">新</el-tag>
                        <el-tag style="cursor:pointer" type="success" size="mini" v-else effect="plain">老</el-tag>
                    </template>
                </el-table-column>
                    <el-table-column
                        width="150"
                            label="微信">
                            <template slot-scope="scope" v-if="scope.row.WeChat">
                                <el-tooltip class="item" v-if="scope.row.ManagerWechatList.length==0" effect="dark" content="暂无微信所有者信息" placement="bottom">
                                    <el-link type="info">{{scope.row.WeChat}}</el-link>
                                </el-tooltip>
                                <el-tooltip v-else  class="item" effect="dark" placement="bottom">
                                    <div slot="content">
                                        <p v-for="(v,i) in scope.row.ManagerWechatList" :key="i">
                                            <b>{{v.Name}}</b>
                                            ({{v.WeChat+":"+v.NickName}})
                                            <br/>
                                        </p>
                                    </div>
                                    <el-link type="info">{{scope.row.WeChat}}</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                <el-table-column property="QQ" label="QQ"></el-table-column>

                 <el-table-column property="QQGroupName" label="QQ群"></el-table-column>
                <el-table-column property="Name" label="名称"></el-table-column>
                <el-table-column property="AliTrademanager" label="阿里旺旺"></el-table-column>
                <el-table-column property="LastLoginTime" width="160px" label="最后登录时间"></el-table-column>
                <el-table-column
                    width="60px"
                    label="等级">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.Grade==1" class="tag_btn" size="mini" type="" effect="dark">C</el-tag>
                        <el-tag v-else-if="scope.row.Grade==2" class="tag_btn" size="mini" type="" effect="dark">B</el-tag>
                        <el-tag v-else class="tag_btn" size="mini" type="" effect="dark">A</el-tag>
                    </template>
                </el-table-column>
                <el-table-column property="CompletionRate" label="完单率"></el-table-column>
                <el-table-column  label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="!scope.row.IsInvalid" size="mini" @click="invalid(scope.row)">标记无效</el-button>
                        <el-button v-else type="danger" @click="canelInvalid(scope.row)" size="mini" >已标记无效</el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>
        </el-dialog>
        <el-drawer
        :title="'任务明细----------预计：'+num+'  实际：'+okNum"
        size="600"
        
        :visible.sync="drawer"
        direction="btt">
            <div style="padding-left:20px;padding-right:20px">

                <div style="float:right;margin-top:-20px" > 
                    <el-checkbox v-model="isMeDetail" @change="changeIsMeDetail">分配给我</el-checkbox>
                    <template v-if="caozuo">
                        <el-button :loading="isOperating" style="margin-left:20px;" @click="batchDispatch" size="mini" type="primary" icon="el-icon-s-check" plain>派单</el-button>
                        <el-button :loading="isOperating" style="margin-left:20px;" @click="importExcel" size="mini" type="primary" icon="el-icon-upload2" plain>导入完成情况</el-button>
                        <el-button :loading="isOperating" style="margin-left:20px;" @click="overTask" size="mini" type="danger" icon="el-icon-check" plain>完成任务</el-button>
                        <input type="file" ref="uploadExcel" v-show="false" accept=".xls,.xlsx" @change="readExcel">
                    </template>
                </div>
                <el-table
                :height="600"
                :data="details"
                 @selection-change="handleSelectionChange"
                style="width: 100%">
                    
                    <el-table-column
                    type="selection"
                    width="55">
                    </el-table-column>
                    <el-table-column
                        prop="Id"
                        width="90"
                        label="Id">
                    </el-table-column>
                    <el-table-column
                        label="商品标题">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" placement="right">
                                <div slot="content" style="width:200px;line-height:18px">{{scope.row.Title}}</div>
                                <div style="width:100%; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{scope.row.Title}}</div>
                            </el-tooltip>
                                <el-link target="_blank"  icon="el-icon-edit"  @click="setTitle(scope.row)" type="primary">修改</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="商品链接">
                        <template slot-scope="scope">
                            <el-link target="_blank"  :href="scope.row.Url" type="primary">点击跳转</el-link>
                                <el-link target="_blank"  icon="el-icon-edit"  @click="setUrl(scope.row)" type="primary">修改</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="图片链接">
                        <template slot-scope="scope">
                            <el-link target="_blank"  @click="showImg(scope.row)" type="primary">点击查看</el-link>

                            <el-link target="_blank"  icon="el-icon-edit"  @click="editImg(scope.row)" type="primary">修改</el-link>
                            <input type="file" ref="upload" v-show="false" accept=".png,.jpg" @change="readFile">
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="购买规格">
                        <template slot-scope="scope">
                              <el-link @click="setKey(scope.row,1)" type="info">{{scope.row.Spec}}</el-link>
                        </template>
                    </el-table-column>
                    <span v-if="task.KeyType==0">
                            <el-table-column
                            label="关键字">
                            <template slot-scope="scope">
                                <el-link @click="setKey(scope.row,2)" type="info">{{scope.row.KeyWords}}</el-link>
                            </template>
                        </el-table-column>
                    </span>
                    <span v-else-if="task.KeyType==1">
                        <el-table-column
                            label="淘口令">
                            <template slot-scope="scope">
                                <el-link @click="setKey(scope.row,2)" type="info">{{scope.row.KeyWords}}</el-link>
                            </template>
                        </el-table-column>
                    </span>
                    <span v-else>
                        <el-table-column
                            label="二维码">
                            <template slot-scope="scope">
                                <el-link @click="setKey(scope.row,2)" type="info">{{scope.row.KeyWords}}</el-link>
                            </template>
                        </el-table-column>
                    </span>
                    <!-- <el-table-column
                        label="关键字">
                        <template slot-scope="scope">
                              <el-link @click="setKey(scope.row,2)" type="info">{{scope.row.KeyWords}}</el-link>
                        </template>
                    </el-table-column> -->
                    <el-table-column
                        label="显示价格">
                        <template slot-scope="scope">
                            <el-link @click="setPrice(scope.row,1)" type="danger">￥{{scope.row.ShowPrice.toFixed(2)}}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="实际价格">
                        <template slot-scope="scope">
                                <el-link @click="setPrice(scope.row,2)" type="danger">￥{{scope.row.Price.toFixed(2)}}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="每单拍几件">
                        <template slot-scope="scope">
                            <el-link type="danger">{{scope.row.BuyNum}}</el-link>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column
                        label="下单留言">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" placement="right">
                                <div slot="content" style="width:200px;line-height:18px">{{scope.row.BuyRemark}}</div>
                                <div style="width:100%; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{scope.row.BuyRemark}}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column> -->
                    <el-table-column
                        label="单数">
                        <template slot-scope="scope">
                            <el-link @click="addOrderAction(scope.row)" type="success">{{scope.row.Num}}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="完成单数">
                        <template slot-scope="scope">
                            <el-tag effect="dark" size="mini"  type="danger" v-if="scope.row.OkNum==0">0</el-tag>
                            <el-tooltip v-else class="item" effect="light" placement="left" :manual="false">
                                <div slot="content">
                                    <el-table
                                    :data="scope.row.Orders"
                                    style="width: 1000px">
                                        <el-table-column
                                            prop="OrderCode"
                                            label="买手提交单号">
                                        </el-table-column>
                                        <el-table-column
                                            prop="AliTrademanager"
                                            label="买手阿里旺旺">
                                        </el-table-column>
                                        <el-table-column
                                            prop="OrderTime"
                                            label="接单时间">
                                        </el-table-column>
                                        <el-table-column
                                            label="买手垫付金额">
                                            <template slot-scope="scope">
                                                <el-link type="danger">￥{{scope.row.AdvanceMoney.toFixed(2)}}</el-link>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="实际佣金">
                                            <template slot-scope="scope">
                                                <el-link type="info" v-if="scope.row.ActualCommission==0">暂无</el-link>
                                                <el-link type="danger" v-else>￥{{scope.row.ActualCommission.toFixed(2)}}</el-link>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="状态">
                                            <template  slot-scope="scope">
                                                <el-tag effect="dark" v-if="scope.row.IsRefund" type="danger" size="mini">已撤销</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==0" size="mini" >待确认</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==1" size="mini" >搜索</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==2" size="mini" >货比</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==3" size="mini" >找到商品</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==4" size="mini" >浏览详情</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==5" size="mini" >收藏关注</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==6" size="mini" >选择规格</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==7" size="mini" >提交订单</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==8" size="mini" >等待打款</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==9" size="mini" >完成支付</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==10" size="mini" >等待审核</el-tag>
                                                <el-tag effect="dark" style="cursor:pointer" v-else size="mini" >已完成</el-tag>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <el-tag effect="dark" size="mini"  type="warning" v-if="scope.row.OkNum<scope.row.Num">{{scope.row.OkNum}}</el-tag>
                                <el-tag effect="dark" size="mini"  type="success" v-else-if="scope.row.OkNum>=scope.row.Num">{{scope.row.OkNum}}</el-tag>                            
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column
                        prop="Remark"
                        label="特殊要求">
                    </el-table-column> -->
                    <!-- <el-table-column
                        
                        label="商家要求">
                        <template slot-scope="scope">
                              <el-link  @click="setSwipeRemark(scope.row)" type="info">{{scope.row.SwipeRemark?scope.row.SwipeRemark:"点击填写"}}</el-link>
                        </template>
                    </el-table-column> -->
                    <el-table-column
                        label="预计佣金总计">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="'实际佣金总计：'+(scope.row.ActualCommission==0?'暂无': scope.row.ActualCommission.toFixed(2))" placement="bottom">
                                <el-link type="danger">￥{{scope.row.ExpectedCommission.toFixed(2)}}</el-link>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="问答">
                                <template slot-scope="scope">
                                    <el-tooltip v-if="scope.row.Problem" class="item" effect="dark" placement="bottom-start">
                                        <div slot="content">
                                            问题：{{scope.row.Problem}}<br/><br/>
                                            答案：{{scope.row.Answer}}<br/><br/>
                                        </div>
                                        <el-link type="primary">查看</el-link>
                                         <el-link @click="updateProblem(scope.row)" type="primary">修改</el-link>
                                    </el-tooltip>
                                    <el-link v-else @click="setProblem(scope.row)" type="primary">补充</el-link>
                                </template>
                    </el-table-column>
                    <el-table-column
                        label="好评">
                        <template slot-scope="scope">

                        <el-link v-if="scope.row.PositiveContent" @click="viewImg(scope.row)" type="primary">查看资源</el-link>

                        
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="子链接">
                        <template v-if="scope.row.ChildNum>0" slot-scope="scope">
                            <el-link target="_blank" @click="taskGetDetailChild(scope.row)"  type="primary">
                                <el-tag  effect="dark" size="small" type="success">{{scope.row.ChildNum}}</el-tag>
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-drawer>


<el-drawer
        :title="'子链接'"
        size="600"
        
        :visible.sync="child"
        direction="btt">
            <div style="padding-left:20px;padding-right:20px">
                <el-table
                :height="600"
                :data="childs"
                 @selection-change="handleSelectionChange"
                style="width: 100%">
                    <el-table-column
                        label="商品标题">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" placement="right">
                                <div slot="content" style="width:200px;line-height:18px">{{scope.row.Title}}</div>
                                <div style="width:100%; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{scope.row.Title}}</div>
                            </el-tooltip>
                                <el-link target="_blank"  icon="el-icon-edit"  @click="setChildTitle(scope.row)" type="primary">修改</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="商品链接">
                        <template slot-scope="scope">
                            <el-link target="_blank"  :href="scope.row.Url" type="primary">点击跳转</el-link>
                                <el-link target="_blank"  icon="el-icon-edit"  @click="setChildUrl(scope.row)" type="primary">修改</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="图片链接">
                        <template slot-scope="scope">
                            <el-link target="_blank"  @click="showImg(scope.row)" type="primary">点击查看</el-link>

                            <el-link target="_blank"  icon="el-icon-edit"  @click="editImg(scope.row)" type="primary">修改</el-link>
                            <input type="file" ref="upload" v-show="false" accept=".png,.jpg" @change="readFile">
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="购买规格">
                        <template slot-scope="scope">
                              <el-link @click="setKey(scope.row,1)" type="info">{{scope.row.Spec}}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="显示价格">
                        <template slot-scope="scope">
                            <el-link @click="setPrice(scope.row,1)" type="danger">￥{{scope.row.ShowPrice.toFixed(2)}}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="实际价格">
                        <template slot-scope="scope">
                                <el-link @click="setPrice(scope.row,2)" type="danger">￥{{scope.row.Price.toFixed(2)}}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="购买单数">
                        <template slot-scope="scope">
                            <el-link type="danger">{{scope.row.BuyNum}}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="好评">
                        <template slot-scope="scope">
                        <el-link v-if="scope.row.PositiveContent" @click="viewImg(scope.row)" type="primary">查看资源</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-drawer>

                <el-image-viewer 
                style="z-index:999999"
                v-show="showViewer" 
                :on-close="closeImg" 
                :url-list="url" />

                <el-dialog
                title="好评内容"
                :visible.sync="videoVisible"
                width="1000px"
                :before-close="handleClose">
                    <div>
                        <b>
                            {{viewRow.PositiveContent}}
                        </b>
                    </div>
                    <div v-if="url.length>0" style="margin-top:20px;">
                        <el-image 
                            v-for="(v,i) in url" :key="i"
                                style="width: 100px; height: 100px;margin-left:5px"
                                :src="v" 
                                :preview-src-list="url">
                            </el-image>
                    </div>
                    <div v-if="viewRow.Video" style="margin-top:20px;">
                        <video src="" id="video1" width="100%" height="400px"  controls>
                            您的浏览器不支持 video 标签。
                        </video>
                    </div>
                </el-dialog>
    </div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

import {orderSetSwipeRemark, orderSetKey, taskAbandoned,taskGroupEnd,pushMain,orderSetPrice, orderCanelInvalid,orderInvalid, orderAdd,taskSetExpectedOverTime,orderBatchAssign,orderGetSwipe,orderSetProblem,taskBatchGet,taskBatchPass,taskBatchOver,commissionGetAll,taskGetDetail,taskOverTask,uri,taskEdit,taskSetTitle,taskSetUrl,taskSetRequirement,taskExistOrder,taskGetDetailChild,taskSetChildTitle,taskSetChildUrl} from '@/request.js'
import XLSX from 'xlsx'

export default {
    components: {
        ElImageViewer
    },
    data(){
        return {
            isOperating:false,
            videoVisible:false,
            showViewer:false,
            url:[],
            caozuo:false,
            drawer:false,
            child:false,
            dialogFormVisible:false,
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                pSize:20,
                pIndex:1,
                status:"",
                createTimes:[],
                payMode:"",
                keyType:"",
                rebateMethod:"",
                isMe:false,
                hasAbandoned:false,
            },
            tableData:[],
            overScope:{},
            overType:1,
            overModel:{
                id:0,
                remark:"",
                externalName:"",
                externalCodes:"",
                startHour:0,
                endHour:0,
            },
            rules: {

            },
            problemRules: {
                problem: [
                    { required: true, message: '请填写问题', trigger: 'blur' },
                    { min: 5, max: 100, message: '长度在 5 到 100 个字符', trigger: 'blur' }
                ],
                answer: [
                    { required: true, message: '请填写答案', trigger: 'blur' },
                    { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                ],
            },
            task:{},
            details:[],
            childs:[],
            loadingSwipe:false,
            problemModel:{
                taskId:0,
                url:"",
                problem:"",
                answer:"",
            },
            requirementModel:{
                id:0,
                expectedOverTime:"",
                rebateMethod:"",
                intercept:"",
                swipeAge:"",
                swipeGender:"",
                swipeBuyerGoodNum:"",
                remark:"",
                swipeRemark:"",
                keyType:"",
            },
            problemVisible:false,
            requirementVisible:false,
            setDetailRow:{},
            setRequirementRow:{},
            batchDispatchVisible:false,
            selDetailRows:[],
            selSwipeRow:[],
            swipeList:[],
            undoneNum:0,
            pIndex:1,
            queryTxt:"",
            setExpectedOverTimeVisible:false,
            setRow:{},
            addOrderVisible:false,
            addOrderModel:{
                TaskId:0,
                DetailId:0,
                ShopId:0,
                SwipePhone:"",
                OrderCode:"",
                AliTrademanager:"",
                AdvanceMoney:0,
                Cost:0,
            },
            orderRules: {
                SwipePhone: [
                    { required: true, message: '请填写刷手手机号', trigger: 'blur' },
                    { min: 11, max: 11, message: '长度为 11 个字符', trigger: 'blur' }
                ],
                OrderCode: [
                    { required: true, message: '请填写买手提交单号', trigger: 'blur' },
                ],
                AliTrademanager: [
                    { required: true, message: '请填写买手阿里旺旺', trigger: 'blur' },
                    { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
                ],
                AdvanceMoney: [
                    { required: true, message: '请填写买手实际垫付金额', trigger: 'blur' },
                ],
                Cost: [
                    { required: true, message: '请填写成本佣金', trigger: 'blur' },
                ],
            },
            num:0,
            okNum:0,
            viewRow:{},
            isMeDetail:false,
            tempDetailData:[],
            titleModel: { title:""},
            titleVisible:false,
            taskMultipleSelection:[],
        }
    },
    created(){
        commissionGetAll({},(res)=>{
            this.commissions=res.Result;
        });
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
       
    },
    methods: {
        batchOver(){
            this.taskMultipleSelection.forEach(x=>{
                this.isOperating=true;
                taskOverTask({
                    taskId:x.Id
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '任务已成功结算',
                            type: 'success'
                        });
                        this.caozuo=false;
                        x.Status=3;
                    }else{
                        this.$message.error(res.Message);
                    }
                    this.isOperating=false;
                });
            })
        },

        taskHandleSelectionChange(val) {
            this.taskMultipleSelection = val;
        },
        setSwipeRemark(scope){
            this.$prompt('请输入商家要求', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue:scope.Remark,
            inputPattern: /\S/,
            inputErrorMessage: '不能为空'
            }).then(({ value }) => {
                orderSetSwipeRemark({
                    detailId:scope.Id,
                    swipeRemark:value,
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.taskGetDetail(this.task);
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
       
            });
        },
        abandoned(scope){
            taskAbandoned({
                id:scope.Id
            },(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    scope.Status=5;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        pause(scope){
            this.$confirm('中止后将调度将无法继续派单, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                taskGroupEnd({
                    taskId:scope.Id
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            }).catch(() => {
                
            });
            // console.log(scope);
        },
        changeIsMeDetail(){
            let newData=[];
            if(this.isMeDetail){
                this.tempDetailData=[];
                this.details.forEach(x=>{
                    this.tempDetailData.push(x);
                    if(x.MyOrderCount>0){
                        newData.push(x);
                    }
                });
                this.details=newData;
            }else{
                this.tempDetailData.forEach(x=>{
                    newData.push(x);
                })
                this.tempDetailData=[];
                this.details=newData;
            }
        },
        setKey(scope,type){
            var val;
            if(type==1){
                val=scope.Spec;
            }else{
                val=scope.KeyWords;
            }
            this.$prompt('请输入新值', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue:val,
            inputPattern: /\S/,
            inputErrorMessage: '不能为空'
            }).then(({ value }) => {
                 if(type==1){
                    scope.Spec=value; 
                }else{
                    scope.KeyWords=value; 
                }
                orderSetKey({
                    detailId:scope.Id,
                    spec:scope.Spec,
                    keyWords:scope.KeyWords,
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.taskGetDetail(this.task);
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
       
            });
        },
        setPrice(scope,type){
            var val;
            if(type==1){
                val=scope.ShowPrice;
            }else{
                val=scope.Price;
            }
            this.$prompt('请输入新值', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue:val,
            inputPattern: /\S/,
            inputErrorMessage: '不能为空'
            }).then(({ value }) => {
                 if(type==1){
                    scope.ShowPrice=value; 
                }else{
                    scope.Price=value; 
                }
                orderSetPrice({
                    detailId:scope.Id,
                    showPrice:scope.ShowPrice,
                    price:scope.Price,
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.taskGetDetail(this.task);
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
       
            });
        },
        canelInvalid(scope){
            orderCanelInvalid({swipeId:scope.Id},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '取消标记成功',
                        type: 'success'
                    });
                    scope.InvalidDate=null;
                    scope.InvalidNum=0;
                    scope.IsInvalid=false;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        invalid(scope){
            orderInvalid({swipeId:scope.Id},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '标记成功',
                        type: 'success'
                    });
                    scope.InvalidDate=res.Result.InvalidDate;
                    scope.InvalidNum=res.Result.InvalidNum;
                    scope.IsInvalid=true;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        addOrderAction(scope){
            if(this.task.Status!=2){
                this.$message({
                    message: '只有进行中的任务可以添加订单',
                    type: 'warning'
                });
                return;
            }
            this.addOrderModel={
                TaskId:scope.TaskId,
                DetailId:scope.Id,
                ShopId:this.task.ShopId,
                SwipePhone:"",
                OrderCode:"",
                AliTrademanager:"",
                AdvanceMoney:scope.Price*scope.BuyNum,
                Cost:0,
            }
            this.addOrderVisible=true;
            this.setDetailRow=scope;
        },
        addOrder(){
            this.isOperating=true;
            this.$refs["orderForm"].validate((valid) => {
                if (valid) {
                    orderAdd(this.addOrderModel,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '添加成功',
                                type: 'success'
                            });
                            this.setDetailRow.OkNum+=1;
                            this.setDetailRow.Orders.push(res.Result);
                            this.addOrderVisible=false;
                        }else{
                            this.$message.error(res.Message);
                        }
                        this.isOperating=false;
                    })
                } else {
                    return false;
                }
            });
        },
        formt(date,fmt) { 
            var o = { 
                "M+" : date.getMonth()+1,                 //月份 
                "d+" : date.getDate(),                    //日 
                "h+" : date.getHours(),                   //小时 
                "m+" : date.getMinutes(),                 //分 
                "s+" : date.getSeconds(),                 //秒 
                "q+" : Math.floor((date.getMonth()+3)/3), //季度 
                "S"  : date.getMilliseconds()             //毫秒 
            }; 
            if(/(y+)/.test(fmt)) {
                    fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length)); 
            }
            for(var k in o) {
                if(new RegExp("("+ k +")").test(fmt)){
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
                }
            }
            return fmt; 
        },     
        setExpectedOverTimeSubmit(){
            taskSetExpectedOverTime({id:this.setRow.Id,expectedOverTime:this.setRow.ExpectedOverTime},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '修改成功',
                        type: 'success'
                    });
                    this.setRow.ExpectedOverTime=this.formt(this.setRow.ExpectedOverTime,"yyyy-MM-dd");
                    this.setExpectedOverTimeVisible=false;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        setExpectedOverTime(scope){
            this.setRow=scope;
            this.setExpectedOverTimeVisible=true;
        },
        handleClose(done){
            if(document.getElementById("video1")){
                document.getElementById("video1").src="";
                document.getElementById("video1").load();
            }
            done();
        },
        viewImg(scope){
            this.url=JSON.parse(scope.ResourcesImg);
            this.viewRow=scope;
            this.videoVisible=true;
            setTimeout(() => {
                document.getElementById("video1").src=scope.Video;
                document.getElementById("video1").load();
            }, 100);
        },
        // viewVideo(scope){
        //     this.videoVisible=true;
        //     setTimeout(() => {
        //         document.getElementById("video1").src=scope.Video;
        //         document.getElementById("video1").load();
        //     }, 100);
        // },
        serachSwipe(){
            this.pIndex=1;
            this.querySwipe();
        },
        huanyipi(){
            this.pIndex+=1;
            this.querySwipe();
        },
        fenpei(){
            let ids="";
            this.selDetailRows.forEach(x=>{
                ids+=x.Id+",";
            });
            let swipes="";
            this.selSwipeRow.forEach(x=>{
                swipes+=x.Id+",";
            });
            orderBatchAssign({
                details:ids.substr(0,ids.length-1),
                swipes:swipes.substr(0,swipes.length-1)
            },(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '分配成功',
                        type: 'success'
                    });
                    this.batchDispatchVisible=false;
                    this.taskGetDetail(this.task);
                    
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        batchDispatch(){
            if(this.selDetailRows.length==0){
                this.$message({
                    message: "请选择需要派单的行",
                    type: 'warning'
                });
                return;
            }
            this.pIndex=1;
            this.batchDispatchVisible=true;
            this.querySwipe();
        },
        querySwipe(){
            let ids="";
            this.selDetailRows.forEach(x=>{
                ids+=x.Id+",";
            });
            this.loadingSwipe=true;
            orderGetSwipe({taskId:this.task.Id,shopId:this.task.ShopId,detailId:ids.substr(0,ids.length-1),pIndex:this.pIndex,queryTxt:this.queryTxt},(res)=>{
                
                this.loadingSwipe=false;
                if(res.IsSuccess){
                    this.swipeList=res.Result.list;
                    this.undoneNum=res.Result.undoneNum;
                }else{
                    this.$message.error(res.Message);
                    this.swipeList=[]
                    this.undoneNum=res.Result.undoneNum;
                }
            })
        },
        submitproblem(){
            this.$refs["problemForm"].validate((valid) => {
                if (valid) {
                    this.problemModel.taskId=this.setDetailRow.TaskId;
                    this.problemModel.url=this.setDetailRow.Url;
                    orderSetProblem(this.problemModel,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '设置成功',
                                type: 'success'
                            });
                            this.setDetailRow.Problem=this.problemModel.problem;
                            this.setDetailRow.Answer=this.problemModel.answer;
                            this.problemVisible=false;
                        }else{
                            this.$message.error(res.Message);
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        submitRequirement(){
            this.$refs["requirementForm"].validate((valid) => {
                if (valid) {
                    this.requirementModel.id =  this.setRequirementRow.Id;
                    taskSetRequirement(this.requirementModel,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '设置成功',
                                type: 'success'
                            });
                            
                            this.requirementVisible=false;
                            this.setRequirementRow.ExpectedOverTime=this.requirementModel.expectedOverTime;
                            this.setRequirementRow.RebateMethod=this.requirementModel.rebateMethod;
                            this.setRequirementRow.Intercept=this.requirementModel.intercept;
                            this.setRequirementRow.SwipeAge=this.requirementModel.swipeAge;
                            this.setRequirementRow.SwipeGender=this.requirementModel.swipeGender;
                            this.setRequirementRow.SwipeBuyerGoodNum=this.requirementModel.swipeBuyerGoodNum;
                            this.setRequirementRow.Remark=this.requirementModel.remark;
                            this.setRequirementRow.SwipeRemark=this.requirementModel.swipeRemark;
                            this.setRequirementRow.KeyType=this.requirementModel.keyType;
                            this.setRequirementRow.RebateMethod=this.requirementModel.rebateMethod;
                        }else{
                            this.$message.error(res.Message);
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        updateProblem(scope){
            this.problemModel={
                taskId:0,
                url:"",
                problem:scope.Problem,
                answer:scope.Answer,
            };
            this.setDetailRow=scope;
            this.problemVisible=true;
        },
        setProblem(scope){
            this.problemModel={
                taskId:0,
                url:"",
                problem:"",
                answer:"",
            };
            this.setDetailRow=scope;
            this.problemVisible=true;
        },
        setRequirement(scope){
            this.requirementModel={
                expectedOverTime:scope.ExpectedOverTime,
                rebateMethod:scope.RebateMethod,
                intercept:scope.Intercept,
                swipeAge:scope.SwipeAge,
                swipeGender:scope.SwipeGender,
                swipeBuyerGoodNum:scope.SwipeBuyerGoodNum,
                remark:scope.Remark,
                swipeRemark:scope.SwipeRemark,
                keyType:scope.KeyType,
            };
            this.setRequirementRow=scope;
            this.requirementVisible=true;
            
        },
        closeImg(){
            this.showViewer=false;
        },
        readFile(e){
            pushMain(this.task.ShopId,this.setDetailRow.Title ,e.target.files[0],(res)=>{
                console.log(res);
            })
        },
        editImg(scope){
            this.setDetailRow=scope;
            this.$refs.upload.click();
        },
        setTitle(scope){
            this.$prompt('请输入商品标题', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue:scope.Title,
            inputPattern: /\S/,
            inputErrorMessage: '不能为空'
            }).then(({ value }) => {
                taskSetTitle({
                    detailId:scope.Id,
                    title:value,
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.taskGetDetail(this.task);
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
       
            });
        },
        setChildTitle(scope){
            this.$prompt('请输入子链接标题', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue:scope.Title,
            inputPattern: /\S/,
            inputErrorMessage: '不能为空'
            }).then(({ value }) => {
                taskSetChildTitle({
                    childId:scope.Id,
                    title:value,
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        taskGetDetailChild({detailId:scope.DetailId},(res)=>{
                            this.childs=res.Result;
                            this.child=true;
                        });
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
       
            });
        },
        setUrl(scope){
            this.$prompt('请输入商品链接', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue:scope.Url,
            inputPattern: /\S/,
            inputErrorMessage: '不能为空'
            }).then(({ value }) => {
                taskSetUrl({
                    detailId:scope.Id,
                    url:value,
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.taskGetDetail(this.task);
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
       
            });
        },
        setChildUrl(scope){
            this.$prompt('请输入商品链接', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue:scope.Url,
            inputPattern: /\S/,
            inputErrorMessage: '不能为空'
            }).then(({ value }) => {
                taskSetChildUrl({
                    childId:scope.Id,
                    url:value,
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        taskGetDetailChild({detailId:scope.DetailId},(res)=>{
                            this.childs=res.Result;
                            this.child=true;
                        });
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
       
            });
        },
        showImg(scope){ 
            this.url=[scope.Img];
            this.showViewer=true;
        },
        editTask(scope){
            console.log(scope.StartHour);
            this.overModel={
                id:scope.Id,
                remark:scope.ReviewRemark,
                externalName:scope.ExternalName,
                externalCodes:scope.ExternalCodes,
                startHour:scope.StartHour,
                endHour:scope.EndHour,
            }
            this.overScope=scope;
            this.dialogFormVisible=true;
            this.overType=2;
        },
        taskGetExl(scope){
            window.open(uri+"/TaskBatch/GetExl?id="+scope.Id);
        },
        taskGetExlNoDone(scope){
            window.open(uri+"/TaskBatch/GetExlNoDone?id="+scope.Id);
        },

        overTask(){
            this.$confirm('确认结算此工单吗,?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.isOperating=true;
                taskOverTask({
                    taskId:this.task.Id
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '任务已成功结算',
                            type: 'success'
                        });
                        this.caozuo=false;
                        this.task.Status=3;
                    }else{
                        this.$message.error(res.Message);
                    }
                    this.isOperating=false;
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        readExcel(e) {
            this.isOperating=true;
            const files = e.target.files;
            if (files.length <= 0) {
                //如果没有文件名
                return false;
            }
            const fileReader = new FileReader();
            fileReader.onload = ev => {
            try {
                const data = ev.target.result;
                const workbook = XLSX.read(data, {
                    type: "binary"
                });
                const wsname = workbook.SheetNames[0]; //取第一张表
                const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //获取到XLSX表格中的数据,并生成json格式的数据类型
                let arr = [];
                ws.forEach((value, index, ws) => {
                    var model = this.details.find((element) => element.KeyWords ==  ws[index]["商品搜索关键字"].toString().trim()
                    &&element.Title==ws[index]["商品名称"].toString().trim()
                    &&element.OkNum<element.Num);
                    if(!model){
                        model=this.details.find((element) => element.KeyWords == 
                        ws[index]["商品搜索关键字"].toString().trim()
                        &&element.Title==ws[index]["商品名称"].toString().trim());
                    }
                    if(model){
                        this.okNum+=1;
                        model.OkNum+=1;
                        if(!model.Orders){
                            model.Orders=new Array();
                        }
                        arr.push({
                            Id:0,
                            TaskId:this.task.Id,
                            DetailId:model.Id,
                            OrderCode: ws[index]["买手提交单号"].toString().trim(),
                            AliTrademanager:ws[index]["买手旺旺名称"].toString().trim(),
                            OrderTime:this.toTime(ws[index]["接单时间"],"-"),
                            AdvanceMoney:ws[index]["买手实际垫付金额"],
                            Cost:ws[index]["第三方佣金"],
                            ActualCommission:0,
                            IsRefund:false,
                            Status:11,
                            PayStatus:3,
                            ReviewNotes:"",
                            SwipeId:0,
                        });
                    }else{
                        this.$notify({
                            title: '警告',
                            message: ws[index]["商品名称"].toString().trim()+'-'+ws[index]["商品搜索关键字"].toString().trim()+'未匹配到工单内容',
                            type: 'warning',
                            
                            duration: 0
                        });
                    }
                    
                })
                    taskExistOrder({json:JSON.stringify(arr)},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                            message: '导入成功',
                            type: 'success'
                        });
                        }
                        else{
                            this.$message.error(res.Message);
                        }
                    });
                } catch (e) {
                    this.$message({
                        message: '填写数据错误或模板错误，请核对',
                        type: 'warning'
                    });
                    return false;
                }
                
            };
            fileReader.readAsBinaryString(files[0]);
            this.isOperating=false;
        },
        toTime(numb, format){
            const time = new Date((numb - 1) * 24 * 3600000 + 1)
            time.setYear(time.getFullYear() - 70)

            var timea=time.valueOf();
            var h=8; //h為小時數
            timea=timea-(h*3600*1000); //可加可減
            timea=new Date(timea);

            const year = timea.getFullYear() + ''
            const month = timea.getMonth() + 1 + ''
            const date = timea.getDate() - 1 + ''
            const hours = timea.getHours();
            const minutes = timea.getMinutes();
            const seconds = timea.getSeconds();
            const t = hours+":"+minutes+":"+seconds;
            if (format && format.length === 1) {
                return year + format + month + format + date + " " + t
            }
            return year + (month < 10 ? '0' + month : month) + (date < 10 ? '0' + date : date)
        },
        importExcel(){
            this.$refs.uploadExcel.click();
        },
        taskGetDetail(v){
            taskGetDetail({taskId:v.Id},(res)=>{
                this.details=res.Result;
                this.num=0;
                this.okNum=0;
                this.isMeDetail=false;
                this.details.forEach(x=>{
                    this.num+=x.Num;
                    this.okNum+=x.OkNum;
                });
                this.drawer=true;
                this.task=v;
                if(v.Status==2){
                    this.caozuo=true;
                }
            })
        },
        taskGetDetailChild(v){
            taskGetDetailChild({detailId:v.Id},(res)=>{
                this.childs=res.Result;
                this.child=true;
            })
        },
        submitOver() {
            if(this.overScope.startHour<8||this.overScope.startHour>18){
                this.$message({
                    message: '开始时间不能小于8点，不能大于18点',
                    type: 'warning'
                });
                return false;
            }
            if(this.overScope.endHour<9||this.overScope.endHour>21){
                this.$message({
                    message: '结束时间不能小于9点，不能大于21点',
                    type: 'warning'
                });
                return false;
            }
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    if(this.overType==1){
                        taskBatchPass(this.overModel,(res)=>{
                            if(res.IsSuccess){
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.dialogFormVisible=false;
                                this.overScope.Status=2;
                                this.overScope.ReviewTime=res.Result.ReviewTime;
                                this.overScope.ReviewManagerName=res.Result.ReviewManagerName;
                                this.overScope.ExternalName=this.overModel.externalName;
                                this.overScope.ExternalCodes=this.overModel.externalCodes;
                                this.overScope.ReviewRemark=this.overModel.remark;
                            }else{
                                this.$message.error(res.Message);
                            }
                        });
                    }else if(this.overType==2){
                        taskEdit(this.overModel,(res)=>{
                            if(res.IsSuccess){
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                                this.dialogFormVisible=false;
                                this.overScope.ExternalName=this.overModel.externalName;
                                this.overScope.ExternalCodes=this.overModel.externalCodes;
                                this.overScope.ReviewRemark=this.overModel.remark;
                            }else{
                                this.$message.error(res.Message);
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        pass(scope){
            this.overScope=scope;
            this.overType=1;
            this.overModel={
                id:scope.Id,
                remark:"",
                externalCodes:"",
                externalName:"",
                startHour:scope.StartHour,
                endHour:scope.EndHour,
            };
            this.dialogFormVisible=true;
        },
        over(scope){
            this.$prompt('请填写不通过原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                }).then(({ value }) => {
                    taskBatchOver({remark:value,id:scope.Id},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            scope.Status=4;
                            scope.ReviewTime=res.Result.ReviewTime;
                            scope.ReviewRemark=value;
                            scope.ReviewManagerName=res.Result.ReviewManagerName;
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消操作'
                });       
            });

        },
        query(){
            this.isLoading=true;
            taskBatchGet({
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                queryTxt:this.queryModel.queryTxt,
                payMode:this.queryModel.payMode==""?0:parseInt(this.queryModel.payMode),
                keyType:this.queryModel.keyType==""?99:parseInt(this.queryModel.keyType),
                rebateMethod:this.queryModel.rebateMethod==""?99:parseInt(this.queryModel.rebateMethod),
                status:this.queryModel.status==""?-1:parseInt(this.queryModel.status),
                createTimes:this.queryModel.createTimes==null?"[]":JSON.stringify(this.queryModel.createTimes),
                isMe:this.queryModel.isMe,
                hasAbandoned:this.queryModel.hasAbandoned,
            },(res)=>{
                this.tableData=res.Result;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
                payMode:"",
                keyType:"",
                rebateMethod:"",
                status:"",
                createTimes:[],
                isMe:false,
                hasAbandoned:false,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        },
        handleSelectionChange(val) {
            this.selDetailRows = val;
        },
        swipeSelectionChange(val){
            this.selSwipeRow = val;
        }
    }
}
</script>
<style scoped>
.row{
    margin-top:10px;
    margin-bottom: 10px;
}
</style>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>